import { c as _c } from "react/compiler-runtime";
import { CookieConsent } from "@repo/ui/components/ui/cookie-consent";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const Route = createFileRoute("/_public")({
  component: PublicLayout
});
function PublicLayout() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Outlet, {}), /*#__PURE__*/_jsx(CookieConsent, {
        variant: "mini",
        learnMoreHref: "/om/integritet",
        description: "Vi anv\xE4nder cookies f\xF6r att s\xE4kerst\xE4lla att du f\xE5r den b\xE4sta upplevelsen p\xE5 v\xE5r webbplats. F\xF6r mer information om hur vi anv\xE4nder cookies, se v\xE5r integritetspolicy."
      })]
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}